export enum MessageOpcode {
  STATUS_CONNECT = 0,
  NOTHING = -1,
  STATUS_REQUEST = 2,
  STATUS_READY = 4,
  STATUS_START = 6,
  UPDATE_STATUS = 7,
  STOP_TEST = 9,
  GO_TO_CHARTS = 10,
  UPDATE_CONFIG = 11,
  SCENE_SET_TEST = 12,
  SCENE_SET_MENU = 13,
  MANAGEMENT_CONFIG = 14,
  STATE = 15,
  CURRENT_TEST_DETAILS = 16,
  ACTION = 17,
  DEVICE_CONFIG = 18,
  RECONNECT_CONTROLLERS = 19,
  CALIBRATE = 155,
  CALIBRATION_UPDATE = 156,
  VA_TEST_START = 20,
  VA_TEST_NEXT = 21,
  VA_TEST_UPDATE = 22,
  CONTRAST_TEST_START = 30,
  CONTRAST_TEST_UPDATE = 31,
  CONTRAST_TEST_NEXT = 32,
  COLOR_TEST_START = 40,
  COLOR_TEST_NEXT = 41,
  COLOR_TEST_UPDATE = 42,
  AMSLER_GRID_START = 50,
  AMSLER_GRID_NEXT = 51,
  AMSLER_GRID_UPDATE = 52,
  FDT_TEST_START = 60,
  FDT_TEST_UPDATE = 62,
  DYSLEXIA_TEST_START = 70,
  DYSLEXIA_TEST_NEXT = 71,
  DYSLEXIA_TEST_UPDATE = 72,
  PUPILLOMETRY_TEST_START = 80,
  PUPILLOMETRY_TEST_UPDATE = 81,
  CONTINUOUS_PERFORMANCE_TEST_START = 100,
  CONTINUOUS_PERFORMANCE_UPDATE = 102,
  OCULAR_MOTILITY_TEST_START = 90,
  OCULAR_MOTILITY_TEST_UPDATE = 91,
  COVER_TEST_START = 110,
  COVER_TEST_NEXT = 111,
  COVER_TEST_UPDATE = 112,
  STEREO_ACUITY_TEST_START = 120,
  STEREO_ACUITY_TEST_NEXT = 121,
  STEREO_ACUITY_TEST_UPDATE = 122,
  VIDEONYSTAGMOGRAPHY_TEST_START = 130,
  VIDEONYSTAGMOGRAPHY_TEST_NEXT = 131,
  VIDEONYSTAGMOGRAPHY_TEST_UPDATE = 132,
  KINETIC_TEST_START = 140,
  KINETIC_TEST_NEXT = 141,
  KINETIC_TEST_UPDATE = 142,
  VIRTUAL_ASSISTANCE_VIDEO_UPDATE = 150,
  SKIP_VIRTUAL_ASSISTANCE = 151,
  SKIP_CALIBRATION = 157,
  DYSCALCULIA_TEST_START = 160,
  DYSCALCULIA_TEST_NEXT = 161,
  DYSCALCULIA_TEST_UPDATE = 162,
  WCST_TEST_START = 180,
  WCST_TEST_NEXT = 181,
  WCST_TEST_UPDATE = 182,
  READING_ASSESSMENT_TEST_START = 170,
  READING_ASSESSMENT_TEST_NEXT = 171,
  READING_ASSESSMENT_TEST_UPDATE = 172,
  NPCT_TEST_START = 190,
  NPCT_TEST_UPDATE = 191,
  OKN_TEST_START = 200,
  OKN_TEST_NEXT = 201,
  OKN_TEST_UPDATE = 202,

  // Reliability protocol (additive; legacy peers ignore unknown opcodes).
  // TEST_START_ACK: headset confirms it received a start command.
  // LINK_PING/LINK_PONG: web -> headset -> web round-trip probe.
  TEST_START_ACK = 210,
  LINK_PING = 211,
  LINK_PONG = 212,

  SYSTEM_OVERLAY = 220,
  HEADSET_REMOVED = 221,
  // 222 is REQUEST_LOG on the headset.
  EYE_TRACKING_UNHEALTHY = 223,
}
